module.exports = __webpack_public_path__ + "media/images/photo/Anyno-5cda5b37112df01b4e0aea61e1521624.png";